export default __webpack_public_path__ + "static/media/ttb.574d7cc4.svg";